const uniPillar = [
    {course: "GEC/hostel mods in this branch", done: false},
    {course: "GEX/ES2660", done: false},
    {course: "CS1101S/CS1010/CS1010E/CS1010J/CS1010S/CS1010X", done: false},
    {course: "GEA1000/BT1101/ST1131/DSA1101", done: false},
    {course: "GESS/hostel mods in this branch", done: false},
    {course: "GEN/hostel mods in this branch", done: false},

];


export default uniPillar;